import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';

const Terms = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '21px' : '48px',
          fontWeight: 800,
          color: 'white',
          textAlign: 'center',
          paddingBottom: isMobile ? '20px' : '40px'
        }}>
        Champsverse Terms and Conditions
      </Typography>
      <Typography
        style={{
          fontSize: isMobile ? '14px' : '24px',
          fontFamily: 'Baloo2',
          fontWeight: 500,
          padding: isMobile ? '5px 0' : '10px 0',
          color: 'white',
          margin: isMobile ? '0 5%' : '0 10%'
        }}>
        Effective Date: 01/03/2025
      </Typography>
      <Typography
        style={{
          fontSize: isMobile ? '14px' : '24px',
          fontFamily: 'Baloo2',
          fontWeight: 500,
          padding: isMobile ? '5px 0' : '10px 0',
          color: 'white',
          margin: isMobile ? '0 5%' : '0 10%'
        }}>
        Welcome to Champsverse!
      </Typography>
      <Typography
        style={{
          fontSize: isMobile ? '14px' : '24px',
          fontFamily: 'Baloo2',
          fontWeight: 500,
          padding: isMobile ? '5px 0' : '10px 0',
          color: 'white',
          margin: isMobile ? '0 5%' : '0 10%'
        }}>
        Champsverse is a creative platform designed for children and young creators to engage, express, and showcase
        their talents. Before using our services, please carefully read these Terms and Conditions.
      </Typography>
      <ol style={{ margin: isMobile ? '2% 5%' : '3% 10%', color: 'white' }}>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Account Creation and Parental Consent
          <ul style={{ fontWeight: 500 }}>
            <li>Users must be at least 13 years old to independently create an account.</li>
            <li>
              For users under 13, a parent or legal guardian must create and manage the account on behalf of the child.
            </li>
            <li>Parental consent is mandatory for all users below 13 years of age.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Account Responsibility
          <ul style={{ fontWeight: 500 }}>
            <li>
              Users (or parents/guardians) are responsible for maintaining the confidentiality of their account
              credentials.
            </li>
            <li>You are responsible for all activities under your account.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Uploading and Ownership of Work
          <ul style={{ fontWeight: 500 }}>
            <li>
              Users can upload photos of creative work, audio/music pieces, writings such as stories, poems, articles.
            </li>
            <li>
              By uploading, users grant Champsverse a non-exclusive, worldwide, royalty-free license to use, display,
              and promote the content within the platform.
            </li>
            <li>
              Champsverse does not scrutinize the authenticity or originality of uploaded content. If you believe a
              copyright infringement has occurred, please contact: admin@champsverse.com.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Usage of Uploaded Content
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse may feature or showcase user-uploaded works for promotional or operational purposes.</li>
            <li>
              Champsverse may offer to sell original user works with a special written royalty agreement between
              Champsverse and the creator (or parent/guardian).
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Community Guidelines
          <ul style={{ fontWeight: 500 }}>
            <li>All content must be appropriate for a family-friendly audience.</li>
            <li>No violent, hateful, abusive, or otherwise inappropriate content is allowed.</li>
            <li>
              Champsverse reserves the right to delete any content, comment, or account that violates community
              guidelines.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          Content Moderation and Reporting
          <ul style={{ fontWeight: 500 }}>
            <li>Users can report inappropriate content or behavior.</li>
            <li>
              Champsverse will investigate reports and take necessary action, including removing content or suspending
              accounts.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          User Interactions
          <ul style={{ fontWeight: 500 }}>
            <li>Users can like, comment, and react to posts.</li>
            <li>Champsverse reserves the right to remove any comment that violates our guidelines.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Profile and Social Features
          <ul style={{ fontWeight: 500 }}>
            <li>Users can upload a profile image.</li>
            <li>Users will have a personal wall where friends&apos; activities will be displayed.</li>
            <li>Users can create collections, dedicate works to friends, build clans, and join clubs</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          Leaderboards and Achievements
          <ul style={{ fontWeight: 500 }}>
            <li>
              Leaderboards will track various aspects such as number of works, activity points, benevolence points,
              achievement points, and popularity points.
            </li>
            <li>
              Users can earn badges such as &ldquo;Masterpiece&rdquo;, &ldquo;Treasure&rdquo;, &ldquo;Hall of
              Fame&rdquo;.
            </li>
            <li>Users can win virtual valuables like silver, gold, ruby, and diamond awards.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Quests, Contests, and Special Events
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse will host thousands of quests and contests for users to participate in.</li>
            <li>Special rules may apply for specific events; participation implies acceptance of those rules.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Virtual Goods Terms
          <ul style={{ fontWeight: 500 }}>
            <li>Activity points can be converted to coins.</li>
            <li>Coins can be redeemed for virtual gifts or donated to charities and good causes.</li>
            <li>Virtual goods have no real-world monetary value unless expressly stated.</li>
            <li>Some redemption features may be available only within India.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Plans and Upload Limits
          <ul style={{ fontWeight: 500 }}>
            <li>A free plan allows users to upload up to 1350 works.</li>
            <li>Champsverse may introduce premium plans and limits may vary accordingly.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Account Deactivation and Deletion
          <ul style={{ fontWeight: 500 }}>
            <li>Users can deactivate or delete their accounts at any time.</li>
            <li>After deletion, users have 30 days to recover their account before permanent removal.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          Termination of Access
          <ul style={{ fontWeight: 500 }}>
            <li>
              Champsverse reserves the right to suspend or terminate any account without prior notice if users violate
              these Terms or engage in unethical conduct.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          Data Privacy and Security
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse prioritizes user privacy and uses reasonable measures to protect data.</li>
            <li>However, no platform is 100% secure, and users accept associated risks.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Third-Party Links and Services
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse may include links to third-party services.</li>
            <li>Champsverse is not responsible for third-party content, policies, or practices.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Prohibited Activities
          <Typography>Users must not:</Typography>
          <ul style={{ fontWeight: 500 }}>
            <li>Hack or disrupt the platform.</li>
            <li>Introduce malicious software.</li>
            <li>Harass, threaten, or harm others.</li>
            <li>Engage in any activity that damages Champsverse or its users.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Intellectual Property Rights
          <ul style={{ fontWeight: 500 }}>
            <li>
              All trademarks, logos, badges, and platform content (excluding user-uploaded work) are the exclusive
              property of Champsverse.
            </li>
            <li>Use of Champsverse branding requires prior written consent.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Changes to Terms
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse reserves the right to modify these Terms at any time.</li>
            <li>
              Users will be notified of significant changes. Continued use of Champsverse constitutes acceptance of
              updated Terms
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Limitation of Liability
          <ul style={{ fontWeight: 500 }}>
            <li>
              Champsverse is not liable for damages resulting from the use of the platform, including data loss or
              exposure to inappropriate content uploaded by users.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          {' '}
          Disclaimer of Warranties
          <ul style={{ fontWeight: 500 }}>
            <li>Champsverse is provided “as is” and “as available” without warranties of any kind.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Force Majeure
          <ul style={{ fontWeight: 500 }}>
            <li>
              Champsverse is not responsible for delays or failures due to events beyond its control, including natural
              disasters, internet outages, and government actions.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Governing Law and Jurisdiction
          <ul style={{ fontWeight: 500 }}>
            <li>These Terms are governed by the laws of India, Tamil Nadu.</li>
            <li>Any disputes will be resolved in the courts located in Tamil Nadu, India.</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Parental Responsibility
          <ul style={{ fontWeight: 500 }}>
            <li>
              Parents and guardians are fully responsible for monitoring their child’s use of Champsverse and ensuring
              compliance with these Terms.
            </li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 800,
            padding: isMobile ? '5px 0' : '10px 0'
          }}>
          Contact Information
          <Typography>For any questions, feedback, or complaints, please contact: admin@champsverse.com</Typography>
        </li>
      </ol>
    </>
  );
};

export default Terms;
